import React, {Component} from 'react';
import { Select, Input, Card, Table, Row, Col, Popconfirm, message,Modal } from 'antd';
import {post} from "../../actions";
import {applicationName, uuid} from "../../utils";
import ViewModal from "./ViewModal";

const { Option } = Select;
const { Search } = Input;

class DataManage extends Component {

    columns = [
        {
            title: '标题',
            dataIndex: 'title',
            key: 'title',
            render: (text, record) =>{
                return (<Row gutter={15} >
                    {record.coverPic ? <Col span={4}><img src={record.coverPic} style={{height:100,maxWidth:'100%',objectFit:"cover"}}/></Col> : ""}
                    <Col span={ record.coverPic ? 20 : 24} >
                        <div style={{width: record.coverPic ? 650 : 800, position:'relative',height:100}}>
                        <span style={{fontSize:16,
                            fontWeight:'bolder',
                            overflow:"hidden",
                            textOverflow:"ellipsis",
                            whiteSpace:"nowrap",
                            display: "block",}}>{record.title}</span>
                            <span style={{
                                overflow:"hidden",
                                textOverflow:"ellipsis",
                                display:"-webkit-box",
                                WebkitLineClamp: 3,
                                webkitBoxOrient: "vertical",
                                wordBreak: "break-all",
                                position:'absolute',
                                top:30
                            }}>{record.summary}</span>
                        </div>
                    </Col>
                </Row>)
            },
            width: 850
        },
        {
            title: '关键词',
            dataIndex: 'labelNames',
            key: 'labelNames',
            render:(text, record) =>{
                if(record.labelNames && record.labelNames.length > 0){
                    return (<div style={{
                        overflow:"hidden",
                        textOverflow:"ellipsis",
                        whiteSpace:"nowrap",
                        display: "block",
                        width:100
                    }}>{
                        record.labelNames.map((item, index) =>{
                            // 关键词最多显示3个
                            if(index < 3){
                                return <span style={{marginLeft: 5}}>{item}</span>;
                            }
                        })
                    }</div>)
                }
            }
        },
        {
            title: '作者',
            dataIndex: 'submitter',
            key: 'submitter',
        },
        {
            title: '更新时间',
            dataIndex: 'updateDate',
            key: 'updateDate',
        },
        {
            title: '操作',
            dataIndex: 'option',
            key: 'option',
            align: 'center',
            render: (text, record) =>{
                return (<span>
                <a onClick={() => this.viewArticle(record)}>查看</a>
                <Popconfirm key={uuid()} placement="topLeft" title={"您确定要删除吗？"}
                            onConfirm={() => this.deleteById(record.id)} okText="是" cancelText="否">
                            <a style={{marginLeft: 15}}>删除</a>
                </Popconfirm>
            </span>)
            }
        }
    ];

    state = {
        total : 0,
        dataSource : []
    };

    params = {
        start: 1,
        size: 10,
        searchType : "",
        searchStr : ""
    };

    constructor(props){
        super(props);
    }

    componentDidMount() {
        this.loadData(this.params)
    }

    loadData = (params) =>{
        let url = "/cm-sites-" + applicationName() + "/dataManage/list";
        post(url,params,(res) =>{
            if(res.status === 200){
                this.setState({
                    total: res.data.count,
                    dataSource: res.data.data
                })
            }
        });
    };

    searchConditionChange = (value) =>{
        this.params.searchType = value;
    };

    pageChange = (page, pageSize) => {
        this.updateTableData(page, pageSize);
    };

    onShowSizeChange = (current, size) => {
        this.updateTableData(current, size);
    };

    updateTableData = (start, size) =>{
        this.params = {
            ...this.params,
            start: start,
            size:size
        };
        this.loadData(this.params);
    };

    viewArticle = (record) =>{
        this.refs.viewModal.showModal(record);
    };

    deleteById = (mediaFusionId) =>{
        let url = "/cm-sites-" + applicationName() + "/dataManage/deleteById";
        post(url,{mediaFusionId},(res) =>{
            if(res.status === 200){
                message.info("删除成功！");
                this.updateTableData(1, 10);
            }else {
                message.error("删除失败！");
            }
        });
    };

    search = (value) =>{
        this.params.searchStr = encodeURIComponent(value.trim());
        if(value && !this.params.searchType){
            message.warn("请先选择搜索字段");
            return;
        }
        this.updateTableData(1, 10);
    };

    render() {
        return (
            <Card extra={<p style={{height:18}}>
                <span style={{ paddingRight: 10 }}>搜索字段</span>
                <span><Select style={{ width: 200 }}
                    placeholder="请选择"
                    onChange={value => this.searchConditionChange(value)}
                    allowClear
                >
                    <Option value="title">标题</Option>
                    <Option value="keywords">关键词</Option>
                    <Option value="submitter">作者</Option>
                </Select></span>
                <span><Search
                    placeholder="请输入关键字"
                    onSearch={value => this.search(value)}
                    style={{ width: 200 }}
                /></span>
            </p>} style={{ margin:15 }}>
                <ViewModal ref={'viewModal'}/>
                <Table dataSource={this.state.dataSource} columns={this.columns}
                       scroll={{y:document.body.clientHeight - 332}}
                       pagination={{
                           showQuickJumper: true,
                           current: this.params.start,
                           total: this.state.total,
                           onChange: this.pageChange,
                           style: {marginRight: '20px'},
                           showTotal: total => `共 ${total} 条数据`,
                           showSizeChanger: true,
                           pageSizeOptions: ['10', '20', '30', '40'],
                           onShowSizeChange: this.onShowSizeChange
                       }}/>
            </Card>
        );
    }
}

export default DataManage;